import { GET_FORECAST_WEATHER } from '../../constants';

const initialState = {
  data: {},
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case GET_FORECAST_WEATHER.LOAD:
      return {
        ...state,
        loading: true,
      };
    case GET_FORECAST_WEATHER.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case GET_FORECAST_WEATHER.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
